import i18n from 'modules/core/lib/i18n'

import { BUSINESS_VARIANT, ENTERPRISE_VARIANT } from 'modules/upsell/lib/selfUpsell/plans/utils'

type VariantType = typeof BUSINESS_VARIANT | typeof ENTERPRISE_VARIANT | null

interface InstalledStatusResult {
  label: string
  variant: 'positive' | 'neutral'
}

export const getInstalledStatus = (
  isInstalled: boolean,
  variant: VariantType,
  hasEnterpriseVariant: boolean,
  from: 'subscription' | 'bundle' | 'overload' | null
): InstalledStatusResult => {
  // If is installed and variant is business, return business
  if (isInstalled && variant === BUSINESS_VARIANT) {
    return {
      label: 'Business',
      variant: 'positive',
    }
  }

  // If is installed and variant is enterprise and has enterprise variant, return enterprise
  if (isInstalled && variant === ENTERPRISE_VARIANT && hasEnterpriseVariant) {
    return {
      label: 'Enterprise',
      variant: 'positive',
    }
  }
  // If is installed via enterprise bundle and variant is enterprise and does not have enterprise variant, return business
  if (isInstalled && variant === ENTERPRISE_VARIANT && !hasEnterpriseVariant && from === 'bundle') {
    return {
      label: 'Business',
      variant: 'positive',
    }
  }
  return {
    label: i18n.t('marketplace.revamp.not_in_your_plan'),
    variant: 'neutral',
  }
}
